import { render, staticRenderFns } from "./SttDictionaryAssignToBot.vue?vue&type=template&id=a29a384a&scoped=true"
import script from "./SttDictionaryAssignToBot.vue?vue&type=script&lang=js"
export * from "./SttDictionaryAssignToBot.vue?vue&type=script&lang=js"
import style0 from "./SttDictionaryAssignToBot.vue?vue&type=style&index=0&id=a29a384a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29a384a",
  null
  
)

export default component.exports